import { defineComponent as _defineComponent } from 'vue'
import InlineSvg from 'vue-inline-svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'InlineIcon',
  props: {
    name: null
  },
  setup(__props: any) {



return { __sfc: true,InlineSvg }
}

})